<!--
Author: TangChen
Date: 2018-11-19
Desc: 适当性信息组件，由index.js 配置引入
-->
<template>
    <div class="comp-inv-info comp">
        <el-row class="acct-box two-cols-form">
            <el-form
                v-if="acctInfo.professionflag"
                ref="acctInfo"
                :model="acctInfo"
                :rules="rules"
                label-width="140px"
                class="acct-form"
                size="small"
                v-on:submit.native.prevent
            >
                <el-col :span="24">
                    <el-form-item label="投资者类型：" class="form-text">
                        <div class="text-con">
                            {{ $cache.getDict("120051", userInfo.professionflag) }}
                        </div>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="投资者有效期：">
                        <div v-if="userInfo.professionflag == 1" class="text-con">
                            {{ $util.fmtDate(acctInfo.effectdate) }}
                        </div>
                        <div v-else class="text-con">长期</div>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <div class="area-title">财务状况</div>
                </el-col>
                <el-col :span="24">
                    <el-form-item
                        label="年收入（元）："
                        prop="annualincome"
                        :class="{ required: required }"
                    >
                        <el-input
                            v-model.trim="acctInfo.annualincome"
                            :placeholder="$util.getConfig().hideFunc ? '请输入年收入' : ''"
                            :disabled="
                                !$util.getConfig().hideFunc || riskLock.indexOf('annualincome') > -1
                            "
                            :maxlength="16"
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item
                        label="收入来源："
                        prop="incomesource"
                        :class="{ required: required }"
                    >
                        <el-select
                            v-model="acctInfo.incomesource"
                            filterable
                            :placeholder="$util.getConfig().hideFunc ? '请选择收入来源' : ''"
                            :disabled="
                                !$util.getConfig().hideFunc || riskLock.indexOf('incomesource') > -1
                            "
                        >
                            <el-option
                                v-for="item in incomesources"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="资产：" prop="assets" :class="{ required: required }">
                        <el-select
                            v-model="acctInfo.assets"
                            filterable
                            :placeholder="$util.getConfig().hideFunc ? '请选择资产' : ''"
                            :disabled="
                                !$util.getConfig().hideFunc || riskLock.indexOf('assets') > -1
                            "
                        >
                            <el-option
                                v-for="item in assetss"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="债务：" prop="debt" :class="{ required: required }">
                        <el-select
                            v-model="acctInfo.debt"
                            filterable
                            :placeholder="$util.getConfig().hideFunc ? '请选择债务' : ''"
                            :disabled="!$util.getConfig().hideFunc || riskLock.indexOf('debt') > -1"
                        >
                            <el-option
                                v-for="item in debts"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <div class="area-title">投资经验</div>
                </el-col>
                <el-col :span="24">
                    <el-form-item
                        label="投资学习经历："
                        prop="investmentedu"
                        :class="{ required: required }"
                    >
                        <el-select
                            v-model="acctInfo.investmentedu"
                            filterable
                            :placeholder="$util.getConfig().hideFunc ? '请选择投资学习经历' : ''"
                            :disabled="
                                !$util.getConfig().hideFunc ||
                                riskLock.indexOf('investmentedu') > -1
                            "
                        >
                            <el-option
                                v-for="item in investmentedus"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item
                        label="投资工作经历："
                        prop="investmentwork"
                        :class="{ required: required }"
                    >
                        <el-select
                            v-model="acctInfo.investmentwork"
                            filterable
                            :placeholder="$util.getConfig().hideFunc ? '请选择投资工作经历' : ''"
                            :disabled="
                                !$util.getConfig().hideFunc ||
                                riskLock.indexOf('investmentwork') > -1
                            "
                        >
                            <el-option
                                v-for="item in investmentworks"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item
                        label="投资相关经验："
                        prop="investmentexp"
                        :class="{ required: required }"
                    >
                        <el-select
                            v-model="acctInfo.investmentexp"
                            filterable
                            :placeholder="$util.getConfig().hideFunc ? '请选择投资相关经验' : ''"
                            :disabled="
                                !$util.getConfig().hideFunc ||
                                riskLock.indexOf('investmentexp') > -1
                            "
                        >
                            <el-option
                                v-for="item in investmentexps"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <div class="area-title">投资目标及风险偏好</div>
                </el-col>
                <el-col :span="24">
                    <el-form-item
                        label="投资期限："
                        prop="investmentterm"
                        :class="{ required: required }"
                    >
                        <el-select
                            v-model="acctInfo.investmentterm"
                            filterable
                            :placeholder="$util.getConfig().hideFunc ? '请选择投资期限' : ''"
                            :disabled="
                                !$util.getConfig().hideFunc ||
                                riskLock.indexOf('investmentterm') > -1
                            "
                        >
                            <el-option
                                v-for="item in investmentterms"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item
                        label="期望收益："
                        prop="execeptedearning"
                        :class="{ required: required }"
                    >
                        <el-select
                            v-model="acctInfo.execeptedearning"
                            filterable
                            :placeholder="$util.getConfig().hideFunc ? '请选择期望收益' : ''"
                            :disabled="
                                !$util.getConfig().hideFunc ||
                                riskLock.indexOf('execeptedearning') > -1
                            "
                        >
                            <el-option
                                v-for="item in exceptedearnings"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item
                        label="可承受损失："
                        prop="affordableloss"
                        :class="{ required: required }"
                    >
                        <el-select
                            v-model="acctInfo.affordableloss"
                            filterable
                            :placeholder="$util.getConfig().hideFunc ? '请选择可承受损失' : ''"
                            :disabled="
                                !$util.getConfig().hideFunc ||
                                riskLock.indexOf('affordableloss') > -1
                            "
                        >
                            <el-option
                                v-for="item in affordableloss"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <!-- <el-col :span="24">
                    <el-form-item label="职务：" prop="position" :class="{'required':required}">
                        <el-input
                            v-model.trim="acctInfo.position"
                            placeholder="请输入职务"
                            :maxlength="20"
                            :disabled="riskLock.indexOf('position')>-1"
                        />
                    </el-form-item>
                </el-col> -->
                <el-col :span="24">
                    <el-form-item
                        label="投资品种："
                        prop="investfundtypeArr"
                        :class="{ required: required }"
                    >
                        <el-checkbox-group
                            v-model="acctInfo.investfundtypeArr"
                            class="checkbox-list"
                            :disabled="
                                !$util.getConfig().hideFunc ||
                                riskLock.indexOf('investfundtype') > -1
                            "
                        >
                            <el-checkbox
                                v-for="item in investfundtypes"
                                :key="item.subitem"
                                :label="item.subitem"
                            >
                                {{ item.subitemname }}
                            </el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <div class="area-title">其他</div>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="不良诚信记录来源：" prop="creditrecord" class="required">
                        <el-select
                            v-model="acctInfo.creditrecord"
                            :disabled="!$util.getConfig().hideFunc"
                            filterable
                            :placeholder="
                                $util.getConfig().hideFunc ? '请选择不良诚信记录来源' : ''
                            "
                            v-on:change="
                                acctInfo.creditrecord !== '09' ? (acctInfo.creditText = '') : ''
                            "
                        >
                            <el-option
                                v-for="item in badcerditsourceremarks"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                    <el-form-item
                        label="其他来源说明："
                        prop="creditText"
                        :class="acctInfo.creditrecord === '09' ? 'required' : ''"
                    >
                        <el-input
                            v-model.trim="acctInfo.creditText"
                            :disabled="!$util.getConfig().hideFunc"
                            :placeholder="$util.getConfig().hideFunc ? '请说明具体情况' : ''"
                            :maxlength="64"
                        />
                    </el-form-item>
                </el-col>
                <el-col v-if="isPwdCheck" :span="24">
                    <el-form-item label="交易密码：" prop="pwd" class="required">
                        <el-input
                            v-model.trim="acctInfo.pwd"
                            :disabled="!$util.getConfig().hideFunc"
                            type="password"
                            :placeholder="$util.getConfig().hideFunc ? '请输入交易密码' : ''"
                            :maxlength="16"
                        />
                        <span
                            class="redemp-btn"
                            v-on:click.prevent="$router.push({ name: 'tradepwd' })"
                        >
                            <span class="like-a">忘记密码？</span>
                        </span>
                    </el-form-item>
                </el-col>
                <el-col :span="24" class="btn-group">
                    <el-button
                        v-if="$util.getConfig().hideFunc"
                        type="primary"
                        class="medium"
                        v-on:click="submitInfo('acctInfo')"
                    >
                        保存
                    </el-button>
                    <el-button class="medium" v-on:click="$router.back()">返回</el-button>
                </el-col>
            </el-form>
        </el-row>
        <el-dialog
            title="提示"
            :visible.sync="dialogVisible"
            width="50%"
            :close-on-click-modal="false"
        >
            <el-checkbox v-model="checked" class="check-style"></el-checkbox>
            <span>
                本人承诺，以上所填信息发生重大变化时，本人将主动、及时进行信息更新，以便于贵机构重新评估本人风险承受能力。如本人未进行前述更新导致的投资损失以及其他法律后果由本人自行承担。
            </span>
            <span slot="footer" class="dialog-footer">
                <el-button v-on:click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" :disabled="!checked" v-on:click="gotoSub()">
                    确 定
                </el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import datePicker from "@/components/form/datePicker.vue";
import format from "date-fns/format";
import userApi from "@/api/user";

export default {
    name: "NavInvInfo",
    components: {
        // datePicker
    },
    props: {
        fn: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            userInfo: {},
            acctInfo: { pwd: "", actualctrlnameText: "", creditrecordText: "" },
            isPwdCheck: false,
            creditRecord: [
                { id: "1", name: "良好" },
                { id: "2", name: "不良好" }
            ],
            person: [
                { id: "1", name: "本人" },
                { id: "0", name: "非本人" }
            ],
            incomesources: [],
            assetss: [],
            debts: [],
            investmentedus: [],
            investmentworks: [],
            investmentexps: [],
            investmentterms: [],
            investfundtypes: [],
            exceptedearnings: [],
            affordableloss: [],
            actualctrlidtype: [],
            countrycode: [],
            machinecode: [],
            badcerditsourceremarks: [],
            dateSet: { type: "3", max: "", dis: false },
            riskLock: "",
            required: false,
            query: null,
            dialogVisible: false,
            checked: false,
            rules: {
                /* beneficiary: [
                    { validator: this.paramRequired, mes: "实际受益人", trigger: "change" }
                ], */
                /* position: [
                    { validator: this.paramRequired, mes: "职务", trigger: "blur" }
                ], */
                assets: [
                    {
                        validator: this.assetsRequired,
                        mes: "资产",
                        trigger: "blur"
                    }
                ],
                annualincome: [
                    {
                        validator: this.validAmount,
                        mes: "年收入",
                        trigger: "change"
                    }
                ],
                incomesource: [
                    {
                        validator: this.selRequired,
                        mes: "收入来源",
                        trigger: "change"
                    }
                ],
                debt: [
                    {
                        validator: this.selRequired,
                        mes: "债务",
                        trigger: "change"
                    }
                ],
                investmentedu: [
                    {
                        validator: this.selRequired,
                        mes: "投资学习经历",
                        trigger: "change"
                    }
                ],
                investmentwork: [
                    {
                        validator: this.selRequired,
                        mes: "投资工作经历",
                        trigger: "change"
                    }
                ],
                investmentexp: [
                    {
                        validator: this.selRequired,
                        mes: "投资相关经验",
                        trigger: "change"
                    }
                ],
                investmentterm: [
                    {
                        validator: this.selRequired,
                        mes: "投资期限",
                        trigger: "change"
                    }
                ],
                execeptedearning: [
                    {
                        validator: this.selRequired,
                        mes: "期望收益",
                        trigger: "change"
                    }
                ],
                affordableloss: [
                    {
                        validator: this.selRequired,
                        mes: "可承受损失",
                        trigger: "change"
                    }
                ],
                creditrecord: [
                    {
                        required: true,
                        message: "请选择不良诚信记录来源",
                        trigger: "blur"
                    }
                ],
                creditText: [
                    {
                        validator: this.validateOtherBadRecord,
                        trigger: "change"
                    }
                ],
                investfundtypeArr: [
                    {
                        validator: this.selRequired,
                        mes: "投资品种",
                        trigger: "change"
                    }
                ],
                pwd: [
                    {
                        required: true,
                        message: "请输入交易密码",
                        trigger: "blur"
                    }
                ]
            }
        };
    },
    created() {
        this.userInfo = this.$cache.getUser();
        this.getCollectionInfo();
        // 投资者信息补录接口不支持校验交易密码
        // this.isPwdCheck = this.$cache.getPwdCheck("B1");
        // 初始化数据字典值
        this.incomesources = this.$cache.getDict("120073");
        this.assetss = this.$cache.getDict("150061");
        this.debts = this.$cache.getDict("150064");
        this.investmentedus = this.$cache.getDict("150067");
        this.investmentworks = this.$cache.getDict("150068");
        this.investmentexps = this.$cache.getDict("150069");
        this.investmentterms = this.$cache.getDict("150071");
        this.investfundtypes = this.$cache.getDict("150072");
        this.exceptedearnings = this.$cache.getDict("150073");
        this.affordableloss = this.$cache.getDict("150075");
        this.actualctrlidtype = this.$cache.getDict("130007");
        this.countrycode = this.$cache.getDict("150136");
        this.machinecode = this.$cache.getDict("150137");
        this.badcerditsourceremarks = this.$cache.getDict("120099");

        this.dateSet.max = this.$util.fmtDate(this.$util.getConfig().const.CARD_DATE_MAX);
        this.$set(this.dateSet, "val", "");
        this.$set(this.dateSet, "time", new Date().getTime());
    },
    methods: {
        dateInterval(val) {
            this.acctInfo.actualctrlvalidate = val !== null ? val.replace(/-/g, "") : "";
            this.$refs.acctInfo.validateField("actualctrlvalidate");
        },
        async gotoSub() {
            const _this = this;
            _this.dialogVisible = false;
            // 数据合并提交
            if (
                _this.acctInfo.investfundtypeArr.length &&
                _this.acctInfo.investfundtypeArr.length > 0
            ) {
                _this.acctInfo.investfundtype = _this.acctInfo.investfundtypeArr.join(",");
            } else {
                _this.acctInfo.investfundtype = "";
            }
            let _x = Object.assign({}, _this.acctInfo);
            /* if (_x.actualctrlname !== "本人") {
                _x.actualctrlname = _x.actualctrlnameText;
            } */
            /* if (_x.beneficiary !== "本人") {
                        _x.beneficiary = _x.beneficiaryText;
                    } */
            _x.tradepwd = this.$util.enc(_x.pwd);
            _x.tradepassword = this.$util.enc(_x.pwd);
            delete _x.investfundtypeArr;
            delete _x.pwd;
            const res = await userApi.updateSuitableInfo(_x);
            if (res.data.appsheetserialno) {
                const info = _this.$cache.getUser();
                _this.$store.dispatch("setInfo", info).then(() => {
                    /* _this.$message({
                            type: "success",
                            message: "适当性信息已更新成功" + (_this.fn ? "" : "，3秒后回到个人信息页面"),
                            onClose: function () {
                                if (_this.fn) { _this.$emit("fn-back", true); } else {
                                    _this.$router.push({ name: "info" });
                                }
                            }
                        }); */
                    _this.$cache.refreshUser();
                    const message1 = "适当性信息已更新成功";
                    const message2 = _this.fn ? "" : "秒后回到个人信息页面";
                    const data = {
                        type: "success",
                        message1: message1,
                        message2: message2,
                        onClose: function () {
                            if (_this.fn) {
                                _this.$emit("fn-back", true);
                            } else {
                                _this.$router.push({
                                    name: "info"
                                });
                            }
                        }
                    };
                    if (!_this.fn) {
                        data.message1 = "适当性信息已更新成功，";
                        data.number = 3;
                    }
                    _this.$handleAutoCloseMessage(data);

                    // 暂时屏蔽投资者转换入口
                    /* if (Number(_this.acctInfo.assets) >= 500) {
                            _this.getInvestor();
                        } */
                });
            }
        },
        /* 提交表单数据，校验用户信息 */
        submitInfo(formName) {
            const _this = this;
            _this.$refs[formName].validate((valid) => {
                if (valid) {
                    _this.dialogVisible = true;
                    _this.checked = false;
                } else {
                    this.$errorScroll();
                }
            });
        },
        // 文字字母校验
        paramRequired(rule, value, callback) {
            if (rule.field === "creditrecord") {
                if (this.acctInfo.creditrecord === "2") {
                    this.$util.validateGeneral(
                        rule,
                        this.acctInfo[rule.field + "Text"],
                        callback,
                        rule.mes
                    );
                } else {
                    callback();
                }
            } else {
                if (
                    this.riskLock.indexOf(rule.field) === -1 &&
                    (this.required || value.trim() !== "")
                ) {
                    this.$util.validateGeneral(rule, value, callback, rule.mes);
                } else {
                    callback();
                }
            }
        },
        // 资产校验
        assetsRequired(rule, value, callback) {
            if (this.$util.isEmpty(value)) {
                callback(new Error("请选择资产"));
            } else {
                callback();
            }
        },
        // 资产校验
        selRequired(rule, value, callback) {
            let _x = rule.field === "annualincome" ? "请输入" : "请选择";
            if (
                this.riskLock.indexOf(rule.field) === -1 &&
                this.required &&
                ((rule.field !== "investfundtypeArr" && value.trim() === "") ||
                    (rule.field === "investfundtypeArr" && value.length === 0))
            ) {
                callback(new Error(_x + rule.mes));
            } else {
                callback();
            }
        },
        validateOtherBadRecord(rule, value, callback) {
            if (this.acctInfo.creditrecord === "09" && this.$util.isEmpty(value)) {
                callback(new Error("请输入其他不良诚信来源说明"));
            } else {
                callback();
            }
        },
        validAmount(rule, value, callback) {
            let _x = "请输入";
            const regex = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/;
            if (value.trim() === "") {
                callback(new Error(_x + rule.mes));
            } else if (!regex.test(value)) {
                callback(new Error("年收入输入不正确"));
            } else {
                callback();
            }
        },
        isAmount(val) {
            const _val = this.$util.checkAmount(val);
            clearTimeout(this.query);
            this.query = setTimeout(() => {
                this.$set(this.acctInfo, "assets", _val);
            }, 1);
        },
        async getCollectionInfo() {
            const _this = this;
            const reqRes = await userApi.getSuitableInfo();
            if (reqRes.data) {
                const res = Object.assign(reqRes.data.result1[0], reqRes.data.result2[0]);
                const info = _this.$cache.getUser();
                if (_this.$util.getConfig().hideFunc && info.needfillappro === "0") {
                    _this.getInvestor(_this.acctInfo);
                }
                const _a = res;
                for (let item in _a) {
                    _a[item] = _a[item].trim();
                }
                if (_a.investfundtype.indexOf(",") > -1) {
                    _a.investfundtypeArr = _a.investfundtype.split(",");
                } else {
                    _a.investfundtypeArr = [];
                    if (_a.investfundtype) {
                        _a.investfundtypeArr.push(_a.investfundtype);
                    }
                }
                _this.acctInfo = Object.assign({}, _this.acctInfo, _a || {});
                this.dateSet.max = this.$util.fmtDate(this.$util.getConfig().const.CARD_DATE_MAX);
                this.$set(this.dateSet, "time", new Date().getTime());
                _this.required = res.isrequired === "1";
                _this.riskLock = res.fieldfromrisk;
                if (_this.riskLock.indexOf("investfundtype") > -1) {
                    _this.riskLock += ",investfundtypeArr";
                }
                if (_this.riskLock.indexOf("credit") > -1) {
                    _this.riskLock += ",creditrecord";
                }
            }
        },
        // 获取投资者转换信息
        async getInvestor(resInfo) {
            const _this = this;
            const res = await userApi.combQueryProInvestInfo();
            if (res.data) {
                let paramsIsNull =
                    res.data[0].perfinancialassets &&
                    res.data[0].peravgincome &&
                    res.data[0].perinvestexp &&
                    res.data[0].perinvestwork &&
                    res.data[0].perinvesttype;
                if (res.data[0].professionflag === "0" && paramsIsNull) {
                    // 判断是否符合转换成专业投资者条件
                    const params = {
                        custtype: "3",
                        perfinancialassets: res.data[0].perfinancialassets * 10000,
                        peravgincome: res.data[0].peravgincome * 10000,
                        perinvestexp: res.data[0].perinvestexp,
                        perinvestwork: res.data[0].perinvestwork,
                        perinvesttype: res.data[0].perinvesttype,
                        invtp: "1"
                    };
                    const checkRes = await userApi.acctChangetypeCheck(params);
                    if (checkRes.data) {
                        if (
                            checkRes.data.assetcheckresult &&
                            checkRes.data.assetcheckresult !== "0"
                        ) {
                            _this
                                .$confirm(
                                    "根据您所提交的投资者资料确认您符合专业投资者认定标准，是否立即前往转换为专业投资者？",
                                    "温馨提示",
                                    {
                                        confirmButtonText: "前往转换",
                                        cancelButtonText: "暂不转换",
                                        type: "info"
                                    }
                                )
                                .then(() => {
                                    _this.$router.push({ name: "invchange" });
                                });
                        }
                    }
                }
            }
        },
        actualctrlnameChange(val) {
            if (val === "本人") this.$refs.acctInfo.validateField("actualctrlname");
        } /* ,
        beneficiaryChange (val) {
            if (val === "本人") this.$refs.acctInfo.validateField("beneficiary");
        } */
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";

.comp-inv-info {
    .el-col.el-col-12 {
        height: 51px;
        overflow: hidden;
    }

    .acct-box {
        padding: 20px 160px;

        .el-select {
            width: 79%;

            .el-input {
                width: 100%;
            }
        }

        .el-input,
        .el-textarea {
            width: 79%;
        }

        .person-sel {
            .el-radio + .el-radio {
                margin-left: 20px;
            }

            .el-input {
                width: 40%;
                margin-left: 10px;
            }
        }

        .area-title {
            padding: 8px 0px;
            font-size: 16px;
            line-height: 16px;
            border-bottom: 1px solid #ebebeb;
            color: rgb(0, 142, 223);
            margin-bottom: 10px;
        }
    }

    .check-style {
        margin-right: 10px;
    }
}
</style>
